import { useState } from "react";
import { NavLink } from "react-router-dom";

import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import MuiLink from "@mui/material/Link";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";

import { boxShadowStyle } from "../../config/config.theme";

const USGSLogo = require("../../assets/usgs-logo.png");

const headerItems = [
  {
    label: "Home",
    href: "",
  },
  {
    label: "Data Explorer",
    href: "data-explorer",
  },
  {
    label: "Basin Coordination Data Editor",
    href: "basin-coordination",
  },
];
const Header = ({ baseRoute }) => {
  const [anchorElNav, setAnchorElNav] = useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };
  return (
    <AppBar
      position="sticky"
      sx={{
        flex: "none",
        backgroundColor: "background.main",
        boxShadow: boxShadowStyle,
        px: 2,
      }}
    >
      <Container disableGutters maxWidth={false}>
        <Toolbar disableGutters>
          <MuiLink href={baseRoute ? baseRoute : ""} rel="noopener noreferrer">
            <Box
              sx={{ display: { xs: "none", sm: "none", md: "flex" }, mr: 6 }}
            >
              <img src={USGSLogo} alt="USGS Logo" style={{ height: "2rem" }} />
            </Box>
          </MuiLink>
          <MuiLink href={baseRoute || "/"} style={{ textDecoration: "none" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Typography
                variant="h6"
                noWrap
                sx={{
                  mr: 6,
                  display: { xs: "none", sm: "none", md: "flex" },
                  fontSize: "1.2rem",
                  color: "secondary.contrastText",
                }}
              >
                IWS Basin Data Explorer
              </Typography>
            </Box>
          </MuiLink>

          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "none", sm: "none", md: "flex" },
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            {headerItems.map((item) => (
              <NavLink
                key={item.label}
                to={baseRoute ? baseRoute + item.href : item.href}
                style={() => ({
                  marginRight: "2rem",
                  textDecoration: "none",
                })}
              >
                {({ isActive }) => (
                  <Typography
                    textAlign="center"
                    sx={{
                      color: "secondary.contrastText",
                      fontSize: "0.9rem",
                      textDecoration: isActive ? "underline" : "none",
                      textDecorationColor: "#fff",
                    }}
                  >
                    {item.label}
                  </Typography>
                )}
              </NavLink>
            ))}
          </Box>

          {/* menu on mobile  */}
          <Box sx={{ flexGrow: 1, display: { sm: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon sx={{ color: "secondary.contrastText" }} />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", sm: "block", md: "none" },
              }}
            >
              {headerItems.map((item) => (
                <MenuItem key={item.label} onClick={handleCloseNavMenu}>
                  <NavLink
                    to={baseRoute ? baseRoute + item.href : item.href}
                    style={{
                      textDecoration: "none",
                    }}
                  >
                    <Typography
                      textAlign="center"
                      sx={{
                        color: "primary.contrastText",
                        textDecoration: "none",
                      }}
                    >
                      {item.label}
                    </Typography>
                  </NavLink>
                </MenuItem>
              ))}
            </Menu>
          </Box>

          {/* title on mobile  */}
          <Typography
            variant="h6"
            noWrap
            component="a"
            href={baseRoute || "/"}
            sx={{
              flexGrow: 1,
              mr: 2,
              display: { sm: "flex", md: "none" },
              letterSpacing: ".3rem",
              fontSize: "1.5rem",
              textDecoration: "none",
              color: "secondary.contrastText",
            }}
          >
            NGWOS
          </Typography>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
